import { combineReducers } from "redux";

import auth from "../modules/auth/reducer";
import profile from "../modules/profile/reducer";
import company from "../modules/company/pages/company/reducer";
import product from "../modules/company/pages/product/reducer";
import customerProduct from "../modules/company/pages/customer/reducer";
import overhead from "../modules/company/pages/overhead/reducer";
import sale from "../modules/company/pages/sales-forecast/reducer";
import model from "../modules/company/pages/financial-model/reducer";
import user from "../modules/user/reducer";

// const authPersistConfig = {
//   key: "auth",
//   storage
// };

// export default combineReducers({
//   auth: persistReducer(authPersistConfig, auth),
//   profile,
//   company,
//   product,
//   customerProduct,
//   overhead,
//   sale,
//   model,
//   user
// });

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_REQUEST") {
    console.log("---------------------------------------")
    // let newState = {
    //   auth: state.auth
    // };
    state = {};
  }
  // console.log(state)
  return appReducer(state, action);
};

// const rootReducer = (state, action) => {
//   if (action.type === "SIGNOUT_REQUEST") {
//     let newState = {
//       auth: state.auth
//     };
//     state = newState;
//   }
//   return appReducer(state, action);
// };
const appReducer = combineReducers({
  auth,
  profile,
  company,
  product,
  customerProduct,
  overhead,
  sale,
  model,
  user
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers.js